import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { TwoFactorRequiredComponent } from './components/two-factor-required/two-factor-required.component';

export const authRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'consent', component: LoginComponent },
  { path: 'callback', component: AuthCallbackComponent },
  { path: 'error', component: LoginComponent },
  { path: 'login-failed', component: LoginFailedComponent },
  // Optional self-service 2FA management lives at /app/profile/settings
  // (auth-two-factor-settings, embedded in ProfileSettingsComponent).
  // two-factor-required is the mandatory, non-dismissible Authenticator-app
  // enrollment gate that mfaRequiredGuard (@et/guards) redirects to.
  { path: 'two-factor-required', component: TwoFactorRequiredComponent },
  // Password reset (Better Auth + SecureLinks transport — see
  // docs/plans/2026-07-31-securelinks-password-reset-transport.md in better-auth-standalone).
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'set-password', component: SetPasswordComponent },
];

@NgModule({
  imports: [RouterModule.forChild(authRoutes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
